import { hc } from "hono/client";
import type { AppType } from "./rpc";

export type { AppType };

export function createApiClient(baseUrl: string, headers?: Record<string, string>) {
  return hc<AppType>(baseUrl, { headers });
}
